// src/utils/loadMoment.js

const loadMoment = () => {
    return import('moment-timezone').then(module => {
      const moment = module.default;
      return moment;
    });
  };
  
  export default loadMoment;
  